var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftTataLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.192871 37.0832H15.554V41.4229H11.1472V51.8527H4.74632V41.4229H0.192871V37.0832Z",
    fill: "#486AAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 43.0507L20.0995 51.8527H13.9524L19.9813 37.0832H26.6572L32.8313 51.8527H26.6086L23.3337 43.0507Z",
    fill: "#486AAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3629 37.0832H46.7235V41.4229H42.318V51.8527H35.9174V41.4229H31.3629V37.0832Z",
    fill: "#486AAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5056 43.0507L51.2703 51.8527H45.1232L51.154 37.0832H57.828L64 51.8527H57.7796L54.5056 43.0507Z",
    fill: "#486AAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7323 9.95441C54.1587 8.9073 53.4033 7.90369 52.4636 6.96253C50.3519 4.84655 47.3725 3.08577 43.8466 1.87136C40.2916 0.647553 36.2369 0 32.1164 0C27.9959 0 23.9412 0.647553 20.388 1.87136C16.8603 3.08591 13.8807 4.84669 11.769 6.96253C10.8299 7.90355 10.0721 8.90856 9.49866 9.95624C14.089 8.92568 21.941 7.56503 29.2317 7.42118C29.935 7.40715 30.4192 7.61626 30.738 7.9914C31.1263 8.44823 31.0972 10.0767 31.0877 10.8052L30.8804 29.6353C31.291 29.6479 31.7035 29.6561 32.1164 29.6561C32.5327 29.6561 32.9475 29.6498 33.3581 29.6371L33.1508 10.805C33.1401 10.0767 33.11 8.44809 33.4997 7.99126C33.8193 7.61626 34.3019 7.40715 35.005 7.42104C42.2927 7.56377 50.1429 8.9247 54.7323 9.95441Z",
    fill: "#486AAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7124 12.4032C48.994 10.9932 44.5074 10.7324 40.0805 10.5043C36.2217 10.3052 36.1713 11.5844 36.5565 14.0291C36.5818 14.1783 36.6128 14.3664 36.6495 14.5808C37.9438 21.698 39.5556 27.8227 39.8326 28.8622C49.24 26.8658 56.0244 21.3307 56.0244 14.8285C56.0244 14.0098 55.9179 13.1986 55.7124 12.4032Z",
    fill: "#486AAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.68 14.0291C28.0656 11.5846 28.0162 10.3052 24.1578 10.5043C19.7294 10.7324 15.2417 10.993 8.52075 12.4041C8.31546 13.1994 8.20752 14.0096 8.20752 14.8284C8.20752 17.6387 9.43896 20.358 11.7691 22.6943C13.8808 24.8103 16.8604 26.5711 20.3882 27.7863C21.665 28.2252 23.0124 28.5849 24.4003 28.8726C24.6608 27.8987 26.3096 21.6466 27.618 14.4022C27.6422 14.2634 27.6645 14.1352 27.68 14.0291Z",
    fill: "#486AAE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftTataLogo);
export default __webpack_public_path__ + "static/media/gift_tataLogo.ee91c835941729cdd421084258f1f745.svg";
export { ForwardRef as ReactComponent };